import { OfflineBoltRounded } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import { ReactNode } from 'react';

import { QuickActionMessage } from '../../../chat.types';
import { ChatUserMessageProps } from '../../ChatUserMessage';

export const ChatUserQuickActionMessage = ({ message }: ChatUserMessageProps<QuickActionMessage>): ReactNode => {
  return (
    <Box
      sx={(theme) => ({
        backgroundColor: theme.palette.grey[200],
        padding: 3,
        borderRadius: 2,
        alignSelf: 'flex-end',
        position: 'relative',
        display: 'flex',
        gap: 2,
        maxWidth: '80%',
      })}
    >
      <OfflineBoltRounded
        fill="primary"
        sx={{
          position: 'absolute',
          top: -12,
          left: -12,
        }}
      />
      <Box sx={{ maxWidth: 'md' }}>
        {message.metadata?.title && (
          <Typography color="primary" variant="subtitle2">
            {message.metadata.title}
          </Typography>
        )}
        {message.metadata?.helpText && (
          <Typography color="primary" variant="body2">
            {message.metadata?.helpText}
          </Typography>
        )}
      </Box>
    </Box>
  );
};
